<template>

  <FadeIn
  class="relative overflow-hidden py-16"
  >
    <div
    class="prose relative"
    :class="[
      variantClasses,
      center ? 'mx-auto' : ''
    ]"
    v-interpolation
    v-html="useSanitize(content.content, currentLocale)"
    ></div>
  </FadeIn>

</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  center: {
    type: Boolean,
    default: false,
  }
})

const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

// Content block variants.
// The `variant` field on a content block takes precedence over the legacy
// `highlight` boolean. Existing records without `variant` keep working
// because the fallback branch honours `highlight: true` as before.
const variantClasses = computed(() => {
  const variant = props.content?.variant

  // TL;DR: authoritative summary at the top of an article.
  if (variant === 'tldr') {
    return 'bg-[#f4f1ea] !p-6 rounded-lg'
  }

  // Key takeaways: calmer recap at the end of an article.
  // Faun background box.
  if (variant === 'takeaways') {
    return 'bg-[#e8e5de] !p-6 rounded-lg'
  }

  // Sources: citation list at the end of an article.
  // Smaller text, subtle top border as a separator, transparent background.
  if (variant === 'sources') {
    return 'prose-sm bg-transparent border-t border-[#d0d4df] !pt-8'
  }

  // Callout: generic neutral emphasis within an article body.
  // Matches the legacy `highlight: true` visual, migration path for older content.
  if (variant === 'callout') {
    return 'bg-[#e2e4e9] border-2 border-[#d0d4df] !p-4 rounded-lg'
  }

  // Legacy: records created before the variant field exists.
  if (props.content?.highlight) {
    return 'bg-[#e2e4e9] border-2 border-[#d0d4df] !p-4 rounded-lg'
  }

  // Default body treatment.
  return 'bg-[#f9f8f6]'
})
</script>